import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgExclamationCircle = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 0A12 12 0 1 1 0 12 12 12 0 0 1 12 0m2.35 6.86c.16-1-.77-1.58-2-1.58-1.21 0-2.16.59-2 1.58l1.65 6.3a.44.44 0 0 0 .59.19.4.4 0 0 0 .18-.19Zm0 10a2 2 0 1 0-4-.09.14.14 0 0 0 0 .09 2 2 0 0 0 4 .11z"
    }));
export default SvgExclamationCircle;
